import GenericSwitcherCardPlaceholder from "@ppb/tbd-components-navigation/components/GenericSwitcherCard/view/GenericSwitcherCardPlaceholder.web";
import type { FunctionComponent } from "react";
import SELECTORS from "./EventSwitcherCard.selectors";
import styles from "./EventSwitcherCard.web.module.css";

/**
 * EventView-owned placeholder: the shared skeleton inside this card's own outer surface, so the
 * reserved slot matches the final switcher's width and margins on both breakpoints.
 */
const EventSwitcherCardPlaceholder: FunctionComponent = () => (
  <div className={styles.placeholderSurface} data-testid={SELECTORS.PLACEHOLDER_TEST_ID}>
    <GenericSwitcherCardPlaceholder />
  </div>
);

export default EventSwitcherCardPlaceholder;
